<template>
  <b-container fluid class="mt-3">
    <h3>Athlete</h3>
    <b-row align-v="center">
      <b-col cols="3">
        <b-avatar class="mr-3"></b-avatar>
      </b-col>
      <b-col cols="9" class="text-left">
        {{ registration.athlete.name }}<br>
        {{ registration.athlete.team }}<br>
        Male<br>
      </b-col>
    </b-row>
    <hr>
    <h4>Pre-Bout Examination</h4>
    <b-row>
      <b-col cols="12" md="6">
        <div class="form-group row">
          <label for="blood-pressure-input" class="col-md-4 col-form-label">Blood pressure</label>
          <div class="col-md-4">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              id="blood-pressure-input-systolic"
              max="300"
              min="0"
              placeholder="mmHg"
              required
              v-model="registration.evaluation_pre.blood_pressure_systolic"
              type="number"
            >
          </div>
          <div class="col-md-4">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              id="blood-pressure-input-diastolic"
              max="300"
              min="0"
              placeholder="mmHg"
              required
              type="number"
            >
          </div>
        </div>
      </b-col>
      <b-col cols="12" sm="6">
        <div class="form-group row">
          <label for="heart-rate-input" class="col-md-4 col-form-label">Heart rate</label>
          <div class="col-md-8">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              id="heart-rate-input"
              max="300"
              min="0"
              placeholder="bpm"
              required
              type="number"
            >
          </div>
        </div>
      </b-col>
      <b-col cols="12" sm="6">
        <div class="form-group row">
          <label for="temperature-input" class="col-md-4 col-form-label">Temperature</label>
          <div class="col-md-8">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              id="temperature-input"
              max="50.0"
              min="0.0"
              placeholder="°C"
              required
              type="number"
            >
          </div>
        </div>
      </b-col>
      <b-col cols="12" sm="6">
        <div class="form-group row">
          <label for="o2-saturation-input" class="col-md-4 col-form-label">O2 Saturation</label>
          <div class="col-md-8">
            <input
              class="form-control"
              :disabled="fieldsDisabled"
              id="o2-saturation-input"
              max="100"
              min="0"
              placeholder="%"
              required
              type="number"
            >
          </div>
        </div>
      </b-col>
    </b-row>
    <EvaluationColumnBoolean
      v-for="f in fields"
      :key="f.field"
      :always-comment="true"
      :disabled="fieldsDisabled"
      :field="f.field"
      :label="f.label"
      @update-value="updateValue($event)"
      />
<!--    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled"
<!-        field="ophthalmology"--
<!-                             label="Ophthalmology"/>--
<    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled"--
<!-field="neurology"&ndash;&gt;--
<!-                             label="Neurology"/>--
<!-    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled"--
<!-                             field="cardiovascular-system" label="Cardiovascular System"/>--
<!-    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled"--
<!-                             field="respiratory-system" label="Respiratory System"/>--
<!-    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled" field="thorax"--
<!-                             label="Thorax"/>--
<!-    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled"--
<!-field="abdomen"&ndash;&gt;--
<!-                             label="Abdomen"/>--
<!-    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled"--
<!-                             field="joints-limbs-spine" label="Joints/Limbs/Spine"/>--
<!-    <EvaluationColumnBoolean :always-comment="true" :disabled="fieldsDisabled" field="skin"--
<!-                             label="Skin"/>-->
    <div class="form-group row">
      <label class="col-md-2 col-form-label font-weight-bold">Blood test</label>
    </div>

    <EvaluationColumnBoolean
      v-for="f in fieldsBloodTest"
      :key="f.field"
      :always-comment="true"
      :disabled="fieldsDisabled"
      :field="f.field"
      :label="f.label"
      @update-value="updateValue($event)"
    />
    <EvaluationTextBox :disabled="fieldsDisabled" field="doctocs-comment" label="Doctor's Comment"/>
    <div class="form-group row"> <!--Competition Fit -->
      <label class="col-md-2 col-form-label text-capitalize">Competition fit</label>
      <div class="col-md-2 d-flex">
        <button
          class="col mr-2 btn"
          :class=" isCompetitionFit ? 'btn-success' : 'btn-outline-success'"
          disabled
          type="button"
        >OK</button>
        <button
          class="col btn"
          :class=" isCompetitionFit === false ? 'btn-danger' : 'btn-outline-danger'"
          disabled
          type="button"
        >NOK</button>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <b-button v-if="!savedEvaluation"
                :disabled="!canSaveEvaluation"
                variant="primary" class="col-12 col-md-3"
                @click="saveEvaluation">Save
      </b-button>
      <b-button v-if="savedEvaluation" variant="secondary" class="col-12 col-md-3"
                @click="editEvaluation">Edit
      </b-button>
    </div>
    <hr>
    <div v-if="savedEvaluation && isCompetitionFit">
      <p class="font-weight-bold text-left">Ich habe dem untersuchenden Doktor keinerlei
        Informationen bezüglich
        meiner Gesundheit vorenthalten.
        Ich verstehe, dass die Nicht-Offenlegung betreffend kürzlicher KOs, Krankheiten,
        Medikationen oder
        Gesundheitsproblemen meine Gesundheit gefährden kann.
      </p>
      <p class="text-left">Athlete's signature</p>
      <VueSignaturePad disabled="disabled"
                       field="athletes-signature"
                       label="Athlete's signature"
                       class="border"
                       height="200px"
                       ref="signaturePad"/>
      <div class="d-flex justify-content-end">
        <button v-if="!savedSignature" class="btn btn-primary col-12 col-md-3"
                :disabled="!savedEvaluation"
                @click="savedSignature=true">Save
        </button>
        <button v-else class="btn btn-secondary col-12 col-md-3"
                :disabled="!savedEvaluation"
                @click="savedSignature=false">Edit
        </button>
      </div>
      <div id="signatureCanvas"></div>
    </div>
    <div v-if="savedEvaluation && isCompetitionFit === false" class="font-weight-bold">
      Athlete is not fit for competition, no signature required.
    </div>
    <div class="m-3">
      <b-button variant="success" class="mr-5" v-if="savedSignature && savedEvaluation">Submit
      </b-button>
      <b-button :to="{ name: 'MedicalEvaluationGeneralData', params: {id: $route.params.id }}"
                variant="secondary">Back
      </b-button>
    </div>
  </b-container>
</template>

<script>
import Vue from 'vue';
import VueSignaturePad from 'vue-signature-pad';
import EvaluationColumnBoolean from '../components/EvaluationColumnBoolean.vue';
import EvaluationTextBox from '../components/EvaluationTextBox.vue';

Vue.use(VueSignaturePad);

export default {
  name: 'MedicalEvaluationPreBout',
  components: {
    EvaluationTextBox,
    EvaluationColumnBoolean,
  },
  data() {
    return {
      fields: [
        { label: 'Ears', field: 'ears' },
        { label: 'Nose', field: 'nose' },
        { label: 'Throat', field: 'throat' },
        { label: 'Ophthalmology', field: 'ophthalmology' },
        { label: 'Neurology', field: 'neurology' },
        { label: 'Cardiovascular System', field: 'cardiovascular-system' },
        { label: 'Respiratory System', field: 'respiratory-system' },
        { label: 'Thorax', field: 'thorax' },
        { label: 'Abdomen', field: 'abdomen' },
        { label: 'Joints/Limbs/Spine', field: 'joints-limbs-spine' },
        { label: 'Skin', field: 'skin' },
      ],
      fieldsBloodTest: [
        { label: 'HBS-Ag', field: 'hbs-ag' },
        { label: 'anti-HCV', field: 'anti-hcv' },
        { label: 'HIV 1/2-Ak', field: 'hiv-1-2-ak' },
        { label: 'p24-Ag', field: 'p24-ag' },
      ],
      blood_pressure_systolic: null,
      blood_pressure_diastolic: null,
      heart_rate: null,
      temperature: null,
      o2_saturation: null,
      passed: null,
      notes: '',
      savedEvaluation: false,
      savedSignature: false,
      ears: null,
      nose: null,
      throat: null,
      ophthalmology: null,
      neurology: null,
      'cardiovascular-system': null,
      'respiratory-system': null,
      thorax: null,
      abdomen: null,
      'joints-limbs-spine': null,
      skin: null,
      'hbs-ag': null,
      'anti-hcv': null,
      'hiv-1-2-ak': null,
      'p24-ag': null,
    };
  },
  methods: {
    editEvaluation() {
      this.savedEvaluation = false;
      this.savedSignature = false;
    },
    fetchRegistration() {
      return this.$http.get(
        `registrations/${this.$route.params.id}?expand=evaluation_pre,evaluation_pre_check`,
      );
    },
    updateValue(event) {
      this[event.field] = event.value;
    },
    saveEvaluation() {
      this.savedEvaluation = true;
    },
  },
  computed: {
    canSaveEvaluation() {
      if (
        this.ears !== null
        && this.nose !== null
        && this.throat !== null
        && this.ophthalmology !== null
        && this.neurology !== null
        && this['cardiovascular-system'] !== null
        && this['respiratory-system'] !== null
        && this.thorax !== null
        && this.abdomen !== null
        && this['joints-limbs-spine'] !== null
        && this.skin !== null
        && this['hbs-ag'] !== null
        && this['anti-hcv'] !== null
        && this['hiv-1-2-ak'] !== null
        && this['p24-ag'] !== null
      ) { return true; }
      return false;
    },
    isCompetitionFit() {
      if (
        this.ears === false
        || this.nose === false
        || this.throat === false
        || this.ophthalmology === false
        || this.neurology === false
        || this['cardiovascular-system'] === false
        || this['respiratory-system'] === false
        || this.thorax === false
        || this.abdomen === false
        || this['joints-limbs-spine'] === false
        || this.skin === false
        || this['hbs-ag'] === false
        || this['anti-hcv'] === false
        || this['hiv-1-2-ak'] === false
        || this['p24-ag'] === false
      ) { return false; }
      if (
        this.ears
        && this.nose
        && this.throat
        && this.ophthalmology
        && this.neurology
        && this['cardiovascular-system']
        && this['respiratory-system']
        && this.thorax
        && this.abdomen
        && this['joints-limbs-spine']
        && this.skin
        && this['hbs-ag']
        && this['anti-hcv']
        && this['hiv-1-2-ak']
        && this['p24-ag']
      ) { return true; }
      return null;
    },
    fieldsDisabled() {
      return this.savedEvaluation;
    },
  },
  created() {
    this.registration = this.fetchRegistration();
  },
};
</script>

<style scoped>

</style>
